import Repository from '@/repositories/marketing'
const resource = '/custom_rows'
export default {
    create (payload, config) {
      return Repository.post(`${resource}.json`, payload, config)
    },
    validateName(config){
      return Repository.get(`${resource}/validate_name.json`, config)
    },
}
